<div id="print-section" [innerHtml]="docContent"></div>